import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section-header">
            <PortfolioNextPrevLink data={data} />
            <h2>Description</h2>
          </div>
          <p>
            Microbrik.com is an online pixel art generator. It turns user’s image into pixel art mosaic along with its assembly instructions. Microbrik tackles one of the challenges of pixel art generation which is the inability of the software to measure the aesthetics of generated output. Instead of relying on software, our solution adopted the filter suggestion mechanism prevalent in camera filter applications nowadays. In our method, the input image is pixelated into multiple outputs with different configurations for the user to choose. This resulted in a more intuitive pixel art creation process.
          </p>  
          <br />
          <p>
            Since its launch in 2015, Microbrik.com has been promoting the sales of Uniontoy’s Microbrik plastic brick in multiple regions such as Hong Kong, Taiwan, and Thailand. The mobile applications are scheduled to launch in early 2017.
          </p>
          <br />
          <div className="center">
            <p>
            The mockup of the app.
            </p>
            <iframe src="https://marvelapp.com/i0802f?emb=1" width="390" height="755" allowTransparency="true" frameborder="0"></iframe>
          </div>
          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Komthep Saksriyuttana (Frontend Developer)</li>
              <li>Soravis Prakkamakul (UX/UI Designer, Developer)</li>
            </ul>
          </div>

          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>

      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/microbrik/index.jsx
 **/